<script setup lang="ts">
const isOpen = ref(false);
const tooltip = ref(null);
const props = defineProps({
  position: {
    type: String,
    default: "bottom-left",
  },
  value: String,
  width: {
    type: Number,
    default: 174,
  },
});

const positions = {
  "top-center": "tw-bottom-full tw-left-1/2 -tw-translate-x-1/2",
  "top-right": "tw-left-full -tw-top-4",
  "bottom-center": "tw-top-full tw-left-1/2 -tw-translate-x-1/2",
  "bottom-left": "tw-top-full tw-left-[-24px]",
  "bottom-right": "tw-top-full tw-right-[-28px]",
  "bottom-center-right": "tw-top-full tw-right-[-78px]",
};

const arrowPos = {
  "top-center": "tw-top-full -tw-rotate-180  tw-left-1/2 -tw-translate-x-1/2 -tw-ml-2.5",
  "top-right": "tw-right-full -tw-rotate-90 tw-left-[-13px] tw-top-[14px]",
  "bottom-center": "tw-bottom-full tw-left-1/2 -tw-translate-x-1/2 -tw-ml-2.5",
  "bottom-left": "tw-bottom-full",
  "bottom-right": "tw-bottom-full tw-right-[20px]",
  "bottom-center-right": "tw-bottom-full tw-right-[70px]",
};

onClickOutside(tooltip, () => (isOpen.value = false));
</script>

<template>
  <div class="tw-relative tw-group" :style="`--width: ${props.width}px`" ref="tooltip">
    <div
      @click="isOpen = !isOpen"
      class="tw-flex tw-cursor-pointer tw-relative"
    >
      <span class="tw-absolute -tw-inset-1"></span>
      <slot></slot>
    </div>
    <div
      :class="[
        'group-hover:lg:tw-block lg:tw-hidden tw-z-10 tw-font-medium tw-text-body-sm tw-m-2.5 tw-w-[var(--width)] tw-rounded-[7px] tw-bg-white tw-pt-[9px] tw-pl-[17px] tw-pb-2.5 tw-pr-3 tw-absolute tw-ring-[2.5px] tw-ring-nl-green-100',
        positions[props.position],
        isOpen ? 'max-lg:tw-block' : 'max-lg:tw-hidden'
      ]"
    >
      <span
        :class="[
          'tw-absolute tw-border-b-[8px] tw-border-x-[9px] tw-border-x-transparent tw-border-b-nl-green-100 before:tw-absolute before:tw-content-[\'\'] before:tw-border-b-[5px] before:tw-border-x-[6px] before:tw-border-x-transparent before:tw-border-b-white before:tw-left-1/2 before:-tw-translate-x-1/2 before:tw-top-[3px]',
          arrowPos[props.position],
        ]"
      ></span>
      <span v-html="props.value" className="[&_a]:tw-underline [&_a]:tw-font-semibold [&_a:hover]:tw-no-underline"></span>
    </div>
  </div>
</template>
